module.exports = __webpack_public_path__ + "img/LNB_planner.85fcaa62.svg";